import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * LoadingOverlay component - Shows a loading spinner overlay
 * Conditionally renders children or a full-screen loading overlay with spinner
 *
 * @example
 * ```tsx
 * import { LoadingOverlay } from '@shared/ui-react';
 *
 * function App() {
 *   const [loading, setLoading] = React.useState(false);
 *
 *   return (
 *     <LoadingOverlay loading={loading} label="Lade Daten...">
 *       <div>Your content here</div>
 *     </LoadingOverlay>
 *   );
 * }
 * ```
 */
export const LoadingOverlay = ({ loading, label = 'Loading...', children }) => {
    if (!loading) {
        return _jsx(_Fragment, { children: children });
    }
    return (_jsx("div", { className: "ui-loading-overlay", children: _jsxs("div", { className: "ui-loading-content", children: [_jsx("div", { className: "ui-spinner" }), _jsx("span", { className: "ui-loading-label", children: label })] }) }));
};
